import { render } from "./QuestionFormWithMathKaTeX.vue?vue&type=template&id=0c6a23b6&scoped=true"
import script from "./QuestionFormWithMathKaTeX.vue?vue&type=script&lang=js"
export * from "./QuestionFormWithMathKaTeX.vue?vue&type=script&lang=js"

import "./QuestionFormWithMathKaTeX.vue?vue&type=style&index=0&id=0c6a23b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6a23b6"]])

export default __exports__